import React from 'react';
import { ROUTES } from 'constants/routes';
import { useNavigate } from 'react-router-dom';
import { Button, Result, Row } from 'components';

export const NotAuthorized = React.memo(() => {
  const navigate = useNavigate();
  return (
    <Result
      className={'center'}
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this page."
      extra={
        <Row justify={'center'}>
          <Button type="primary" onClick={() => navigate(ROUTES.home)}>
            Back Home
          </Button>
        </Row>
      }
    />
  );
});
